<template>
  <div class="page pt-5">
    <div class="page__wrapper">
      <app-loader v-if="loader" />
      <template v-else>
        <h3 class="mb-3">
          Перемещение на отгрузку
        </h3>
        <v-card
          v-for="it in cars"
          :key="it.id"
          elevation="1"
          :color="getCarColor(it)"
          class="card-custom"
          ripple
          @click="goToMoving(it.vin)"
        >
          <v-card-text class="text-transform-none">
            {{ it.vin }} <br>
            {{ it.model }}, {{ it.color }} <br>
            Место: {{ it.location.storageDescription }}, {{ it.location.siteDescription }}
          </v-card-text>
        </v-card>
        <template />
      </template>
    </div>
    <div class="page__actions page__actions--home">
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.go(-1)"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        v-if="showAcceptButton"
        class="ml-auto"
        color="success"
        x-large
        @click="confirmationModal = true"
      >
        Подтвердить
      </v-btn>
    </div>
    <result-modal
      v-model="resultModal"
      :title="carInWorkTitle"
      :text="carInWork"
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptDocument"
    />
  </div>
</template>

<script>

import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';

export default {
  name: 'CarsByDocument',
  components: {
    ConfirmationModal,
    ResultModal,
  },
  props: {
    id: String,
  },
  data: () => ({
    loader: true,
    acceptLoader: false,
    documents: [],
    cars: [],
    carInWork: null,
    carInWorkInfo: null,
    carInWorkTitle: '',
    resultModal: false,
    confirmationModal: false,
    errorModal: false,
    errorText: '',
  }),
  computed: {
    showAcceptButton() {
      return this.cars.length
      && this.cars.every((it, i, arr) => (it.status === 'ЗаказЗакрыт' || it.status === '')
      && it.location.storageId === arr[0].location.storageId && it.location.shipment === 'true')
      && !this.acceptLoader;
    },
  },
  async created() {
    await this.getCarByUser();
    this.getDocuments();
  },
  methods: {
    async getCarByUser() {
      const { data: vin } = await this.$http.get('MobileOperatorInterface/BasicOperations/CarByUser').catch((e) => {
        this.onErrorHandler(e);
      });
      this.carInWork = vin;
      if (vin) {
        this.carInWorkInfo = await this.getCarInfo(vin);
      }
      return Promise.resolve();
    },
    async getDocuments() {
      const { data } = await this.$http.get('MobileOperatorInterface/MovementShipping/Documents').catch((e) => {
        this.onErrorHandler(e);
      });
      this.documents = data;
      const { vins } = this.documents.find((it) => it.id === this.id);
      const promises = vins.map((it) => this.getCarInfo(it));
      this.cars = await Promise.all(promises)
        .catch((e) => {
          this.onErrorHandler(e);
        }).finally(() => {
          this.loader = false;
        });
    },
    async getCarInfo(vin) {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${vin}`).catch((e) => {
        this.onErrorHandler(e);
      });
      return Promise.resolve(data);
    },
    async acceptDocument() {
      this.acceptLoader = true;
      await this.$http.post(`MobileOperatorInterface/MovementShipping/Document/${this.id}`, {
        id: '28bec0c2-f0fb-11eb-96de-b1f873d9b25e',
        status: 'Подтверждена',
      }).then(() => {
        this.$router.push('/movement-shipping');
      }).catch((e) => {
        this.onErrorHandler(e);
      }).finally(() => {
        this.acceptLoader = false;
      });
    },
    getCarColor(it) {
      if (it.status === 'ЗаказВРаботе' && it.operation === 'ПеремещениеНаОтгрузку') {
        return 'blue lighten-5';
      }

      if (it.status === 'ЗаказЗакрыт' && it.operation === 'ПеремещениеНаОтгрузку') {
        return 'success lighten-4';
      }

      return 'yellow lighten-4';
    },
    goToMoving(vin) {
      if (this.carInWork && this.carInWork !== vin) {
        this.resultModal = true;
        this.carInWorkTitle = 'У вас уже есть машина в работе';
        return;
      }

      if (this.carInWorkInfo?.operation === 'СвободноеПеремещение' && this.carInWorkInfo?.status === 'ЗаказВРаботе') {
        this.resultModal = true;
        this.carInWorkTitle = 'Эта машина уже в работе в свободном перемещении';
        return;
      }

      this.$router.push({
        name: 'Moving',
        params: { vin },
      });
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>
